import { securedWrap } from '@mop/shared/utils/securedWrap';
import type { NavigationModel } from '@/types/navigationModel';

type PathRef = Ref<NavigationModel[]>;
type NavigationStorage = {
  activePath: PathRef;
};

export default function useMopNavigation() {
  const storage = initStorage<NavigationStorage>('useNavigation');
  const { $navigationList } = useNuxtApp();
  // shallowRef: replaced wholesale, never mutated in place.
  const activePathRef: PathRef = storage.get('activePath') ?? storage.saveAndGet('activePath', shallowRef([]));

  function setPath(currentRoutePath: string) {
    const path: NavigationModel[] = [];
    $navigationList.forEach((item) => findPath(path, item, currentRoutePath));
    activePathRef.value = path;
  }

  function findPath(accumulator: NavigationModel[], category: NavigationModel, path: string) {
    const slug: string = category.getSlug();
    if (!slug) {
      return;
    }

    const isFullMatch = slug === path;
    if (isFullMatch) {
      return accumulator.push(category);
    }
    const isPartialMatch: boolean = new RegExp(`^${slug}`).test(path);
    if (isPartialMatch) {
      accumulator.push(category);
    }
    if (!category.hasChildren()) {
      return;
    }
    category.getChildren().forEach((item) => findPath(accumulator, item, path));
  }

  return securedWrap({
    activePathRef,
    setPath,
  });
}
